module.exports = __webpack_public_path__ + "static/media/PRO.b7d82b5b.svg";